import React, { ReactNode } from "react";

interface Props {
    children: ReactNode;
}

const Header: React.FC<Props> = ({
    children
}) => {
    return (
        <h2 className="black f24 lh24">{children}</h2>
    )
}

export default Header;